import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';

/* __next_internal_client_entry_do_not_use__ default auto */ import { createDemoClient } from '@mui/internal-core-docs/utils/createDemoClient';
const ClientProvider = createDemoClient(import.meta.url, { precompute: { externals: { "@mui/material/Box": Box, "@mui/material/Paper": Paper } } });
export default ClientProvider;
